module.exports = __webpack_public_path__ + "static/img/bg.3b1acf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bg.jpg
// module id = ogGJ
// module chunks = 0